module.exports = __webpack_public_path__ + "static/a-xx-007-art-e4c6fde5240f9145316315019901d9a0.jpg";